import React from 'react';
import { FontIcon } from 'material-ui';
import Icon from '../../../../tc-ui/icon';
import { isValidTime } from '../../../../../utils/validations';
import R from 'ramda';

const SinglePickupDropoff = ({
  index,
  notes,
  pickupOrDropoff,
  onTextFieldChangeWithKeyPath,
  timeLocArray,
  }) => {
  const baseKeyPath = ['data', pickupOrDropoff, index];
  const array = !timeLocArray || R.isEmpty(timeLocArray) ? [{}] : R.clone(timeLocArray);
  return (
    <div>
      {
        array.map(({ time, location }, i) => {
          const disableDeleteButton = i === 0 && array.length === 1;
          const timeNotValid = Boolean(time) && time
            .split(';')
            .filter(x => x && Boolean(x.trim()))
            .some(str => !isValidTime(str));
          return (<div
            key={i}
            className="flex-center"
            style={{  }}
          >
            <div
              style={{
                border: '1px dashed #e0e0e0',
                width: '80%',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ width: '90%' }}>
                <div className="flex-center" style={{ marginBottom: '8px' }}>
                  <label className="flex-center">
                    <FontIcon className="tc-icon-location_on" style={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' }} />
                    Location:
                  </label>
                  <div style={{ marginLeft: '16px', width: '85%', border: '1px solid #ccc', borderRadius: '3px' }}>
                    <input
                      style={{ padding: '4px', fontSize: '14px', border: 'none', width: '100%' }}
                      value={location || ''}
                      onChange={({ target: { value } }) => {
                        onTextFieldChangeWithKeyPath({ keyPath: [...baseKeyPath, 'timeLocArray', i, 'location'], value });
                      }}
                    />
                  </div>
                </div>
                <div className="flex-center">
                  <label className="flex-center">
                    <FontIcon className="tc-icon-watch_later" style={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' }} />
                    Time(s):
                  </label>
                  <div style={{ width: '85%', marginLeft: '24px', border: '1px solid #ccc', borderRadius: '3px' }}>
                    <input
                      style={{ padding: '4px', fontSize: '14px', border: 'none', width: '100%' }}
                      value={time || ''}
                      onChange={({ target: { value } }) => {
                        onTextFieldChangeWithKeyPath({ keyPath: [...baseKeyPath, 'timeLocArray', i, 'time'], value });
                      }}
                    />
                  </div>
                </div>
                <br/>
                {
                  timeNotValid && (
                    <div style={{ color: '#ff4081', marginBottom: '8px' }}>Please enter times with the correct format, such as: "8am; 4:30pm".</div>
                  )
                }
                <div><i>Please separate times with a semicolon, such as: "4:00pm; 4:30pm".</i></div>
              </div>
              <Icon
                className="tc-icon-close"
                style={{
                  color: disableDeleteButton ? 'grey' : '#ff4081',
                  cursor: disableDeleteButton ? 'normal' : 'pointer',
                }}
                onClick={disableDeleteButton ? undefined : () => onTextFieldChangeWithKeyPath({ keyPath: [...baseKeyPath, 'timeLocArray'], value: R.remove(i, 1, timeLocArray) })}
              />
            </div>
            <div className="flex-tc-sb" style={{ marginLeft: '8px', width: '60px' }}>
              {
                array.length - 1 === i && (
                  <Icon
                    className="tc-icon-add"
                    style={{
                      border: '2px solid green',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                    onClick={() => onTextFieldChangeWithKeyPath({ keyPath: [...baseKeyPath, 'timeLocArray'], value: R.append({}, timeLocArray) })}
                  />
                )
              }
            </div>
          </div>)
        })
      }
      <textarea
        style={{ overflowX: 'hidden', width: '80%', marginBottom: '12px' }}
        rows={4}
        placeholder="Enter notes here..."
        defaultValue={notes}
        onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: [...baseKeyPath, 'notes'], value })}
      />
    </div>);
};

export default SinglePickupDropoff;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/pickup-dropff/single-pickupdropoff.jsx